export default __webpack_public_path__ + "static/media/ele-cart.d9432fe6.png";